const common = {
    action: "aksi",
    active: "aktif",
    active_non: "tidak aktif",
    add: "tambah",
    address: "alamat",
    approve: "approve",
    back: "kembali",
    batch: "tanda",
    // brand: "merek",
    brand: "principal",
    category: "kategori",
    cancel: "batal",
    choose: "pilih",
    choose_img: "pilih gambar",
    closing: "penutupan",
    courier: "kurir",
    company: "perusahaan",
    customer: "pelanggan",
    date: "tanggal",
    date_start: "tanggal mulai",
    date_end: "tanggal akhir",
    date_range: "rentang tanggal",
    date_update: "tanggal diperbarui",
    delete: "hapus",
    detail: 'detail',
    description: "deskripsi",
    discount: "potongan",
    difference: "selisih",
    duplicate: 'duplikat',
    edit: "ubah",
    email: "E-mail",
    export_excel: "ekspor ke excel",
    export_csv: "ekspor ke CSV",
    export_pdf: "ekspor ke PDF",
    fullname: "nama lengkap",
    goods: "barang",
    height: "tinggi",
    history: "riwayat",
    image: "gambar",
    info: "keterangan",
    language: "bahasa",
    loading: "menunggu...",
    location: "lokasi",
    length: "panjang",
    name: "nama",
    name_full: "nama lengkap",
    next_month: "bulan depan",
    no: "Nomor",
    note: "catatan",
    no_option: "tidak ada pilihan",
    no_description: "tidak ada deskripsi",
    pass: "kata sandi",
    pass_conf: "konfirmasi kata sandi",
    pass_new: "kata sandi baru",
    pass_reset: "atur ulang kata sandi",
    pass_change: "ubah kata sandi",
    phone: "no. telp",
    prev_month: "bulan sebelumnya",
    price: "harga",
    price_buy: "harga beli",
    price_sell: "harga jual",
    price_retail: "harga retail",
    print: "cetak",
    process: "proses",
    profile: "profil",
    product: "produk",
    quantity: "kuantitas",
    quantity_sell: "kuantitas terjual",
    reference: "referensi",
    reject: "tolak",
    request: "permintaan",
    sales: "sales",
    save: "simpan data",
    search: "cari",
    serial_num: "nomor seri",
    submit: "kirim",
    sku: "SKU",
    supplier: "pemasok",
    status: "status",
    stock: "stok",
    telp: "telp",
    unit: "satuan",
    upload: "unggah",
    user: "pengguna",
    warehouse: "gudang",
    weight: "berat",
    width: "lebar",
    verification: "verifikasi",
}

export default common